/**
 * Lightweight toast event emitter.
 * Call showToast() from anywhere; the Toast component listens and displays it.
 */

type ToastListener = (message: string) => void;
let listener: ToastListener | null = null;

/** Show a toast message to the user */
export function showToast(message: string) {
  listener?.(message);
}

/** Register the toast listener. Returns an unsubscribe function. */
export function onToast(fn: ToastListener): () => void {
  listener = fn;
  return () => {
    listener = null;
  };
}
